import './gb-collection-dropdown-item.tag.html';
import './gb-collection-item.tag.html';
import './gb-collections.tag.html';



// WEBPACK FOOTER //
// ./~/source-map-loader!./src/tags/collections/index.ts